// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__ipmFe","loader":"loader_loader__1AOoV","spinning":"loader_spinning__VQkyb"};